import React, { useState } from "react";
import { toast } from "react-toastify";
import { useUpdateNodeTopicMutation } from "../../../../Services/general/General";
import { Loader } from "react-bootstrap-typeahead";

interface IProps {
  closeUpdateModal: () => void;
  currentNode: any;
  selectedTeam: any;
  refetch: () => void;
}

const UpdateTopicModal: React.FC<IProps> = ({
  closeUpdateModal,
  currentNode,
  selectedTeam,
  refetch,
}) => {
  const [topic, setTopic] = useState(currentNode.topic || "");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updateNodeTopic, { isLoading }] = useUpdateNodeTopicMutation();

  const handleUpdate = async () => {
    const trimmedTopic = topic.trim();
    if (!trimmedTopic) {
      toast.error("Topic cannot be empty.");
      return;
    }
    setIsSubmitting(true);
    try {
      // Adjust payload as per your backend requirements
      const payload = {
        "id": currentNode.id,
        "topic": trimmedTopic,
        "priority": currentNode.priority,
        "ticket_name": currentNode.ticket_name,
        "team": currentNode.team,
        "hide": currentNode.hide,
        "tn_parent": currentNode.tn_parent
      }
      const response = await updateNodeTopic({
        body: payload,
        id: selectedTeam,
      });
      if (response && (response as any).data) {
        toast.success("Updated successfully");
        refetch();
        closeUpdateModal();
      } else {
        toast.error("Failed to update. Please try again.");
      }
    } catch (error: any) {
      toast.error(error?.data?.message || error?.message || "An error occurred while updating");
    } finally {
      setIsSubmitting(false);
    }
  };

  const isUpdateButtonDisabled = !topic.trim() || isSubmitting || isLoading;

  return (
    <div>
      <div className="mt-4">
        <input
          type="text"
          className="form-control"
          placeholder="Topic"
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
          disabled={isSubmitting || isLoading}
          maxLength={100}
          autoComplete="off"
        />
      </div>
      <div className="d-flex justify-content-end mt-4">
        <button
          type="reset"
          className="btn btn-sm btn-white text-hover-danger me-4"
          onClick={closeUpdateModal}
          disabled={isSubmitting || isLoading}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-sm btn-primary"
          onClick={handleUpdate}
          disabled={isUpdateButtonDisabled}
        >
          {isLoading || isSubmitting ? (
            <>
              Updating... <Loader />
            </>
          ) : (
            "Update"
          )}
        </button>
      </div>
    </div>
  );
};

export default UpdateTopicModal;

